var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.category
    ? _c(
        "ul",
        _vm._l(_vm.category, function(ref, index) {
          var name = ref.name
          var product_count = ref.product_count
          var url = ref.url
          var children = ref.children
          return _c(
            "li",
            {
              key: index,
              class: {
                "has-children": children && children.length,
                "is-open": _vm.childrenOpen === index
              }
            },
            [
              _c("a", { attrs: { href: url } }, [
                _c("span", { staticClass: "link" }, [
                  _vm._v(_vm._s(name) + " (" + _vm._s(product_count) + ")")
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "icon icon-arrow-indicators",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      _vm.childrenOpen =
                        _vm.childrenOpen === index ? null : index
                    }
                  }
                })
              ]),
              _vm._v(" "),
              children
                ? _c("CategoryTreeList", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.childrenOpen === index,
                        expression: "childrenOpen === index"
                      }
                    ],
                    attrs: { category: children }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }